module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9073974a46352f66214bf99db01aab28.svg";